import React from 'react'
import * as Bs from 'react-bootstrap'
import * as Bsr from 'react-router-bootstrap'
import DocumentTitle from 'react-document-title'
import Backdrop from '../components/backdrop'
import EventTimeline from '../components/eventTimeline'
import MessagePanel from '../components/messagePanel'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'

/**
 * Dashboard page
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class Dashboard extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired,
    events: React.PropTypes.object.isRequired,
    messages: React.PropTypes.object.isRequired
  }

  static fetchData (store, params) {
    return {
      events: store.get('/events', { limit: 10 }),
      messages: store.get('/account/messages')
    }
  }

  renderDelinq() {
    return (
      <Bs.Alert bsStyle="danger">
        <b>This account has been temporarily disabled</b>.
        Please verify your credit card on file or contact REDIComps at <a href="mailto:info@redicomps.com">info@redicomps.com</a> / <a href="tel:+18005749185">800-574-9185</a>.
      </Bs.Alert>
    )
  }

  render() {
    const { account, events, messages } = this.props
    const isDelinq = account.getIn(['group', 'isDelinq'])

    return (
      <DocumentTitle title="Dashboard">
        <Backdrop url="/images/skyline.jpg">
          {isDelinq && this.renderDelinq()}
          <Bs.Row>
            <Bs.Col xs={8}>
              <h3>Recent activity</h3>
              <EventTimeline events={events.get('data')} />
              <div className="text-center">
                <Bsr.ButtonLink to="events">
                  View all events
                </Bsr.ButtonLink>
              </div>
            </Bs.Col>
            <Bs.Col xs={4}>
              <p>Welcome back <b>{account.get('name')}.</b></p>
              <MessagePanel messages={messages} />
            </Bs.Col>
          </Bs.Row>
        </Backdrop>
      </DocumentTitle>
    )
  }
}

export default Dashboard



// WEBPACK FOOTER //
// ./modules/shared/pages/dashboard.js